import { faPaperclip, faSpinnerThird } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FeatureTooltip } from '@karnov/kui-react'

import { useTranslation } from 'services/i18n'

import { cn } from 'utils/cn'

import type { FC } from 'react'

type Props = {
  attachmentCount: number
  hasPendingUploads: boolean
  onClick: VoidFunction
}

export const AttachmentsPlaceholder: FC<Props> = ({ attachmentCount, hasPendingUploads, onClick }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'message_resources.placeholder' })

  return (
    <FeatureTooltip content={t('tooltip.attachment')} side="top">
      <button
        className="flex h-11 items-center gap-2 rounded-lg border border-light bg-default p-2 pr-3 shadow-hard-sm hover:bg-light"
        onClick={onClick}
        tabIndex={0}
      >
        <div className="flex size-7 items-center justify-center rounded bg-subdued">
          <FontAwesomeIcon
            className={cn('', { 'animate-spin': hasPendingUploads })}
            icon={hasPendingUploads ? faSpinnerThird : faPaperclip}
            size={hasPendingUploads ? 'sm' : undefined}

          />
        </div>
        <div className="mr-1 text-sm font-medium">
          {t('label.attachment', { count: attachmentCount })}
        </div>
      </button>
    </FeatureTooltip>
  )
}
